import React from 'react';
import { GridTableDatum, SurveyTableRow } from '../styles';

interface SurveyAnswer {
  value: string;
}

interface Subscription {
  subscriber: {
    name?: string;
    last_name?: string;
    email: string;
  };
}

interface SurveyAnswers {
  subscription: Subscription;
  answers: SurveyAnswer[];
}

interface SurveyAnswerRowProps {
  surveyAnswers: SurveyAnswers;
  index: number;
}

const SurveyAnswerRow: React.FC<SurveyAnswerRowProps> = ({ surveyAnswers, index }) => {
  const { name, last_name } = surveyAnswers?.subscription?.subscriber;
  const fullName = `${name || ''} ${last_name || ''}`.trim();

  return (
    <SurveyTableRow role="row">
      <GridTableDatum role="cell">
        {fullName || 'Sin nombre'}
      </GridTableDatum>
      <GridTableDatum role="cell">
        {surveyAnswers?.subscription?.subscriber?.email || 'Sin email'}
      </GridTableDatum>
      {surveyAnswers.answers.map((answer, answerIndex) => (
        <GridTableDatum key={`answer-${index}-${answerIndex}`} role="cell">
          {answer.value || 'Sin respuesta'}
        </GridTableDatum>
      ))}
    </SurveyTableRow>
  );
};

export default SurveyAnswerRow;
